const bundleTags = [
	{
		hash: 'faeb0f6e7e5fb6d996d5aa72a9906321e719661530e303d97d6ad6d98553c5da',
		tags: [
			{
				id: 7,
				label: 'High Efficiency',
			},
			{
				id: 5,
				label: 'Summer',
			},
		],
	},
	{
		id: 6,
		hash: 'd38955677bc099fe9e1743ab472f21ad5c95c747e144ac33059c36549d5d930d',
		tags: [
			{
				id: 8,
				label: 'Tax Credit Eligible',
			},
			{
				id: 6,
				label: 'Winter',
			},
		],
	},
	{
		id: 7,
		hash: 'c6259a6227b5f80032b8922c7c450bbb78d85e4d99624e61cb0067059ee692c4',
		tags: [
			{
				id: 7,
				label: 'High Efficiency',
			},
			{
				id: 8,
				label: 'Tax Credit Eligible',
			},
		],
	},
	{
		id: 8,
		hash: 'f0fcb47879d00a4e1a0fd6d1a1fb700e0cf6f19cdfe8873ab3b1a420ad1b08b2',
		tags: [
			{
				id: 8,
				label: 'Tax Credit Eligible',
			},
		],
	},
];
export default bundleTags;
